export default __webpack_public_path__ + "static/media/global.0c5d13e6.svg";